import { useEffect, useState } from 'react';
import { api, getToken, setToken, onAuthChange } from '../services/api';

export interface Usuario {
  id: string;
  email: string;
  nome: string | null;
}

let cachedUser: Usuario | null = null;

export function useAuth() {
  const [user, setUser] = useState<Usuario | null>(cachedUser);
  const [loading, setLoading] = useState(!cachedUser && !!getToken());

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      if (!getToken()) {
        cachedUser = null;
        if (mounted) {
          setUser(null);
          setLoading(false);
        }
        return;
      }
      if (cachedUser) {
        if (mounted) {
          setUser(cachedUser);
          setLoading(false);
        }
        return;
      }
      try {
        const { user: u } = await api.get('/api/auth/me');
        cachedUser = u;
      } catch {
        cachedUser = null;
      }
      if (mounted) {
        setUser(cachedUser);
        setLoading(false);
      }
    };
    load();
    const unsub = onAuthChange(load);
    return () => {
      mounted = false;
      unsub();
    };
  }, []);

  return { user, loading };
}

export async function login(email: string, password: string): Promise<Usuario> {
  const { token, user } = await api.post('/api/auth/login', { email, password });
  cachedUser = user;
  setToken(token);
  return user;
}

export async function register(nome: string, email: string, password: string): Promise<Usuario> {
  const { token, user } = await api.post('/api/auth/register', { nome, email, password });
  cachedUser = user;
  setToken(token);
  return user;
}

export function logout() {
  cachedUser = null;
  setToken(null);
}

// Atualiza o cache local após editar o perfil
export function setUsuarioCache(user: Usuario) {
  cachedUser = user;
}
